import React, {useEffect, useState} from 'react'
import { useSelector } from 'react-redux';
import * as THREE from "three"
import { codiciColoreMetallo } from '../Utils/codiciColore';
import { E_ColoriMetallo } from '../Utils/enumerations';

// Aste di sostegno del laterale Cristal
export default function AstaSostegno({posizione, altezzaAsta}) {  
    const coloreMetallo = useSelector(state => state.uiMainMenu.coloreStrutture);
    const dimensioneAsta = 0.025;  
    const shape1 = new THREE.Shape();    

    const extrudeSettings = {
        steps: 2,
        depth: altezzaAsta,
        bevelEnabled: false,
        bevelThickness: 0.005,
        bevelSize: 0.005,
        bevelOffset: -0.003,
        bevelSegments: 1,
    };

    const generateAstaSostegno = () => {
        shape1.moveTo(-dimensioneAsta, -dimensioneAsta);
        shape1.lineTo(dimensioneAsta, -dimensioneAsta);
        shape1.lineTo(dimensioneAsta, dimensioneAsta);
        shape1.lineTo(-dimensioneAsta, dimensioneAsta);
        shape1.lineTo(-dimensioneAsta, -dimensioneAsta);
        return shape1;
    }

    const [metalColor, setMetalcolor] = useState(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Nero).codice);

    useEffect(() => {  
        if (coloreMetallo === E_ColoriMetallo.Antracite.toString())  setMetalcolor(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Antracite).codice);
        else if (coloreMetallo === E_ColoriMetallo.Bianco.toString()) setMetalcolor(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Bianco).codice); 
    }, [coloreMetallo]);
        
    generateAstaSostegno();
  
    return (
        <mesh position={posizione} rotation={[-Math.PI/2, 0, 0]}>
            <extrudeGeometry args={[generateAstaSostegno(), extrudeSettings]}/>      
            <meshStandardMaterial color={metalColor}/>            
        </mesh>
    )
}
